// extracted by mini-css-extract-plugin
module.exports = {"createGroupButtonContainer":"Product-tab_createGroupButtonContainer_2J9Mh"};